<template>
  <div class="body-content">
    <h1 class="title">Dashboard</h1>

    <!--<add-inspection-grid ></add-inspection-grid>
    <add-damage save="saves" v-on:save-clicked="increment"></add-damage>-->

    <!-- 4-column widgets grid -->
    <div class="widgets-grid">
      <div v-if="showWidgetsGrid" class="widget-card">
        <h3>Active VCNs</h3>
        <div class="widget-count" v-if="!isLoadingActiveVCNs" @click="openVCNModal" style="cursor:pointer">{{
          activeVCNs.length }}</div>
        <div v-if="isLoadingActiveVCNs">Loading...</div>
      </div>
      <div v-if="showWidgetsGrid" class="widget-card">
        <h3>Import Lists</h3>
        <div class="widget-count" v-if="!isLoadingactiveImortVCNs" @click="openImportVcnModal" style="cursor:pointer">{{
          activeImortVCNs.length }}</div>
        <div v-if="isLoadingactiveImortVCNs">Loading...</div>
      </div>
      <div v-if="showNotVerifiedWidget" class="widget-card">
        <h3>Not Verified Transaction</h3>
        <div class="widget-count" v-if="!isLoadingNotVerified" @click="openNotVerifiedModal" style="cursor:pointer">{{
          notVerifiedCount }}</div>
        <div v-if="isLoadingNotVerified">Loading...</div>
      </div>
      <div v-if="showCapturedImagesWidget" class="widget-card">
        <h3>Captured Images</h3>
        <p class="widget-subtitle">(last 30 Days)</p>
        <div class="widget-count" v-if="!isLoadingCapturedImages" @click="openCapturedImagesModal"
          style="cursor:pointer">{{ capturedImagesCount }}</div>
        <div v-if="isLoadingCapturedImages">Loading...</div>
      </div>
      <!--<div class="widget-card" v-for="n in 7" :key="n">
        <h3>Widget {{ n + 1 }}</h3>
        <p>Placeholder content</p>
      </div>-->
    </div>

    <!-- Not Verified Transactions Modal -->
    <div v-if="showNotVerifiedModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Not Verified Transactions ({{ notVerifiedCount }})</h3>
          <div class="search-inline">
            <label class="search-label">Search</label>
            <input type="text" v-model="notVerifiedSearch" placeholder="Container / Seal / Movement"
              class="search-input" />
          </div>
          <div class="select-all-container">
            <input type="checkbox" id="selectAll" v-model="selectAll" @change="toggleSelectAll" />
            <label for="selectAll" style="margin-left: 6px; cursor: pointer;">Select All</label>
            <button class="verify-button" @click="verifySelected" :disabled="!hasSelectedRows">Verify</button>
          </div>
          <button class="close-btn" @click="closeNotVerifiedModal">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="isLoadingNotVerified">Loading...</div>
          <div v-else class="grid-container">
            <RevoGrid hide-attribution :source="filteredNotVerifiedRows" :columns="columns" :theme="compact"
              @afteredit="onCellEdit" />
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-button" @click="closeNotVerifiedModal">Close</button>
        </div>
      </div>
    </div>

    <!-- Active VCNs Modal -->
    <div v-if="showVCNModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Active VCNs ({{ activeVCNs.length }}) </h3>
          <div class="search-inline">
            <label class="search-label">Search</label>
            <input type="text" v-model="activeSearch" placeholder="VCN / Vessel / Voyage / Area" class="search-input" />
          </div>
          <button class="close-btn" @click="closeVCNModal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="vcns-table">
            <thead>
              <tr>
                <th>#</th>
                <th>VCN</th>
                <th>Vessel</th>
                <th>IMP Voyage</th>
                <th>EXP Voyage</th>
                <th>Area</th>
                <th>IS Sail</th>
                <th>Sail Date</th>
                <th colspan="2">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vcn, idx) in filteredActiveVCNs" :key="vcn.vcn || vcn.id || idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ vcn.vcnName }}</td>
                <td>{{ vcn.VesselName }}</td>
                <td>{{ vcn.import_voyageName }}</td>
                <td>{{ vcn.export_voyageName }}</td>
                <td>{{ vcn.area }}</td>
                <td>{{ vcn.IsSail ? 'Yes' : 'No' }}</td>
                <td>{{ vcn.SailDate }}</td>
                <td>
                  <button class="edit-button" @click="editVCN(vcn)">Edit</button>
                </td>
                <td>
                  <button class="edit-button" style="margin-left:8px; background:#198754;"
                    @click="ShowUploadFileList(vcn)">Upload Files</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="ShowUploadFileModal" class="nested-modal-overlay">
          <div class="nested-modal-content">
            <div class="modal-header">
              <h3>Upload Files for M. V. <sapn style="color: blue;">{{ SelectedVcnForUpload.VesselName }}</sapn> Voy
                <span style="color: blue;">{{ SelectedVcnForUpload.import_voyageName == null ?
                  SelectedVcnForUpload.export_voyageName : SelectedVcnForUpload.import_voyageName }}</span> At <span
                  style="color: blue;">{{ SelectedVcnForUpload.area }}</span>
              </h3>
              <button class="close-btn" @click="ShowUploadFileModal = false">&times;</button>
            </div>
            <div class="modal-body">
              <div>
                <div class="form-group">
                  <div class="form-item">
                    <label for="partyname">Party *</label>
                    <select id="partyname" v-model="selectedShortName" style="width:100%">
                      <option value="">Select Party</option>
                      <option v-for="party in linkParties" :key="party.autoid" :value="party.autoid">
                        {{ party.short_name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-item">
                    <label for="onFileChange">Select File(s) *</label>
                    <input type="file" @change="onFileChange" ref="fileAdd" class="btn btn-default" multiple
                      style="width:100%">
                  </div>
                  <div class="form-item">
                    <button class="save-button" @click="uploadFiles" style="margin-top: 20px;">Upload</button>
                  </div>
                </div>
              </div>
              <div v-if="UploadFilesList.length > 0">
                <table class="vcns-table">
                  <thead>
                    <tr>
                      <th>Party</th>
                      <th>No of image</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in UploadFilesList" :key="index">
                      <td>{{ item.short_name }}</td>
                      <td>{{ item.no_of_file }}</td>
                      <td><i class="fas fa-image image-icon" @click="showOverlay(item.vcnID, item.partyId)"
                          title="View Image"></i></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                No Files uploaded.
              </div>
            </div>
            <div class="modal-footer">
              <button class="cancel-button" @click="closeUploadFileModal">Close</button>
            </div>
          </div>
          <div v-if="fileoverlayVisible" class="overlay">
            <div class="overlay-content" style="width:80%; max-width:1000px;">
              <!-- Hidden file inputs accept image and pdf files -->
              <input type="file" ref="addImageInput" style="display:none" @change="onAddImageChange"
                accept="image/*,.pdf" multiple />
              <input type="file" ref="replaceImageInput" style="display:none" @change="onReplaceImageChange"
                accept="image/*,.pdf" />
              <!-- If file extension image then image preview if pdf then pdf preview -->

              <!-- Preview Area -->
              <div v-if="currentImage" style="width:100%; ">
                <!-- Image Preview -->
                <img v-if="isImage(currentImages[currentIndex].filename)" :src="currentImage"
                  style="max-width:100%;max-height:600px" />
                <!-- PDF Preview -->
                <iframe v-else-if="isPdf(currentImages[currentIndex].filename)" :src="currentImage" width="100%"
                  height="400"></iframe>
                <!-- Controls -->
                <div style="margin-top:10px">
                  <button class="nav-button left" @click="prevImage" :disabled="currentIndex === 0"
                    style="background: transparent;"> <i class="fa fa-arrow-circle-left" style="font-size:36px"></i>
                  </button>

                  <button class="nav-button right" @click="nextImage"
                    :disabled="currentIndex === currentImages.length - 1" style="background: transparent;">
                    <i class="fa fa-arrow-circle-right" style="font-size:36px"></i> </button>
                </div>
              </div>
              <div class="no-image" v-else>No images. Click <strong>＋ Add</strong> to upload.</div>


              <!-- Bottom toolbar -->
              <div class="overlay-toolbar">
                <span class="image-counter" v-if="currentImages.length > 0">{{ currentIndex + 1 }} / {{
                  currentImages.length
                }}</span>
                <button class="overlay-action-btn add-img-btn" @click="triggerAddImage" title="Add Image(s)">＋
                  Add</button>
                <button class="overlay-action-btn replace-img-btn" v-if="currentImages.length > 0"
                  @click="triggerReplaceImage" title="Replace Current Image">✎ Replace</button>
                <button class="overlay-action-btn delete-img-btn" v-if="currentImages.length > 0"
                  @click="deleteCurrentImage" title="Delete Current Image">🗑 Delete</button>
                <button class="overlay-action-btn close-img-btn" @click="closeOverlay">X Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-button" @click="closeVCNModal">Close</button>
        </div>
      </div>
    </div>
    
          <!-- Delete Image Confirmation Modal -->
          <div v-if="isDeleteImageConfirmVisible" class="edit-overlay" style="z-index:10001">
            <div class="edit-overlay-content" style="width:35%;">
              <h2>Confirm Delete</h2>
              <p>Are you sure you want to delete this image?</p>
              <div class="form-buttons" style="margin-top:12px;">
                <button type="button" class="save-button" @click="confirmDeleteImage">Yes, Delete</button>
                <button type="button" class="cancel-button" @click="isDeleteImageConfirmVisible = false">Cancel</button>
              </div>
            </div>
          </div>  
    <!-- Advance List Modal (moved to be nested inside Import VCNs modal) -->
    <!-- Import VCNs Modal -->
    <div v-if="showImportVcnModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Import VCNs ({{ activeImortVCNs.length }})</h3>
          <div class="search-inline">
            <label class="search-label">Search</label>
            <input type="text" v-model="importSearch" placeholder="VCN / Vessel / Voyage / Area" class="search-input" />
          </div>
          <button class="close-btn" @click="closeImportVcnModal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="vcns-table">
            <thead>
              <tr>
                <th>#</th>
                <th>VCN</th>
                <th>Vessel</th>
                <th>IMP Voyage</th>
                <th>Area</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vcn, idx) in filteredImportVCNs" :key="vcn.vcnID || vcn.vcnName || idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ vcn.vcnName }}</td>
                <td>{{ vcn.VesselName }}</td>
                <td>{{ vcn.import_voyageName }}</td>
                <td>{{ vcn.area }}</td>
                <td>
                  <button class="edit-button" style="margin-left:8px; background:#6f42c1;"
                    @click="showAdvanceList(vcn)">Advance List</button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
        <!-- Nested Advance List modal rendered on top of the Import VCN modal -->
        <div v-if="showAdvanceModal" class="nested-modal-overlay">
          <div class="nested-modal-content">
            <div class="modal-header">
              <h3>Advance List ({{ advanceListData.length }})</h3>
              <button class="close-btn" @click="closeAdvanceModal">&times;</button>
            </div>
            <div class="modal-body">
              <div v-if="isLoadingAdvanceList">Loading...</div>
              <table v-else class="vcns-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>VCN</th>
                    <th>vessel</th>
                    <th>Voyage</th>
                    <th>Applicant</th>
                    <th>Account</th>
                    <th>No Of Container</th>
                    <th>Download</th>
                    <th>Set CFS/ICD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in advanceListData" :key="row.id || row.vcnName || idx">
                    <td>{{ idx + 1 }}</td>
                    <td>{{ row.vcnName || row.VCN || row.vcn || '' }}</td>
                    <td>{{ row.VesselName || row.vesselName || '' }}</td>
                    <td>{{ row.VoyageName || row.voyageName || row.import_voyageName || '' }}</td>
                    <td>{{ row.ApplicantName || row.applicantName || '' }}</td>
                    <td>{{ row.AccountName || row.accountName || '' }}</td>
                    <td>{{ row.no_of_container ?? row.count ?? row.no_of_containers ?? '' }}</td>
                    <td>
                      <button class="edit-button" style="margin-left:8px; background:#198754;"
                        @click="DownloadFile(row)">Download</button>
                    </td>
                    <td>
                      <button class="edit-button" style="margin-left:8px; background:#0d6efd;"
                        @click="openSetCfsModal(row)">Set CFS/ICD</button>
                    </td>
                  </tr>
                  <tr v-if="advanceListData.length === 0">
                    <td colspan="9">No records found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button class="cancel-button" @click="closeAdvanceModal">Close</button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-button" @click="closeImportVcnModal">Close</button>
        </div>
      </div>
    </div>
    <div v-if="showSetCfsModal" class="modal-overlay">
      <div class="modal-content" style="max-width:800px;">
        <div class="modal-header">
          <h3>Set CFS/ICD for {{ selectedAdvanceRow.vcnName || selectedAdvanceRow.VCN || '' }}</h3>
          <div class="search-inline">
            <label class="search-label">Search</label>
            <input type="text" v-model="blSearch" placeholder="BL No" class="search-input" />
          </div>
          <button class="close-btn" @click="showSetCfsModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <!--bl list for that VCN will be displayed here with checkbox and after selecting the BL and CFS/ICD user can save the details. API call will be made on save and after successful response modal will be closed.-->
          <div>
            <table class="vcns-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Line No</th>
                  <th>BL No</th>
                  <th>CFS/ICD</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(bl) in filteredBlList" :key="bl.blNo">
                  <td><input type="checkbox" v-model="selectedBlIds" :value="bl.blNo" /></td>
                  <td>{{ bl.itemno }}</td>
                  <td>{{ bl.blNo }}</td>
                  <td>{{ bl.cfs_name }}</td>
                </tr>
                <tr v-if="filteredBlList.length === 0">
                  <td colspan="3">No BL records found for this VCN.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <div class="set-cfs-grid">
            <label>Select CFS/ICD</label>
            <select v-model="selectedCfsId">
              <option v-for="cfs in cfsList" :key="cfs.locationid" :value="cfs.locationid">{{ cfs.Name }}</option>
            </select>
            <v-spacer></v-spacer>
            <button class="cancel-button" @click="showSetCfsModal = false">Cancel</button>
            <v-spacer></v-spacer>
            <button class="save-button" @click="saveSetCfs">Save</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Captured Images Modal -->
    <div v-if="showCapturedImagesModal" class="modal-overlay">
      <div class="modal-content captured-images-modal">
        <div class="modal-header">
          <h3>Captured Images - Day Wise Count ({{ capturedImagesCount }})</h3>
          <button class="close-btn" @click="closeCapturedImagesModal">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="isLoadingCapturedImages">Loading...</div>
          <div v-else class="table-wrapper">
            <table class="vcns-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Count</th>
                </tr>
              </thead>
            </table>
            <div class="table-body-scroll">
              <table class="vcns-table">
                <tbody>
                  <tr v-for="(row, idx) in capturedImagesData" :key="row.create_date || idx">
                    <td>{{ idx + 1 }}</td>
                    <td>{{ formatDate(row.create_date) }}</td>
                    <td>{{ row.total }}</td>
                  </tr>
                  <tr v-if="capturedImagesData.length === 0">
                    <td colspan="3">No records found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-button" @click="closeCapturedImagesModal">Close</button>
        </div>
      </div>
    </div>

    <!-- Edit VCN Modal -->
    <div v-if="showEditModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Edit VCN</h3>
          <button class="close-btn" @click="closeEditModal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="edit-grid">
            <label>VCN</label>
            <input v-model="newVcn.vcnName" />
            <label>Vessel</label>
            <input v-model="newVcn.VesselName" />
            <label>IMP Voyage</label>
            <input v-model="newVcn.import_voyageName" />
            <label>EXP Voyage</label>
            <input v-model="newVcn.export_voyageName" />
            <label>Area</label>
            <input v-model="newVcn.area" />
            <label>Is Sail</label>
            <input type="checkbox" v-model="newVcn.IsSail" :true-value="1" :false-value="0" />
            <label>Sail Date</label>
            <input type="text" v-model="newVcn.SailDate" @blur="setValueToFiled()" placeholder="dd/mm/yyyy"
              :disabled="!newVcn.IsSail" />
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-button" @click="closeEditModal">Cancel</button>
          <button class="save-button" @click="saveEdit" :disabled="isSavingEdit">Save</button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'
import { hasPermission } from '../utils/permissions';
import RevoGrid from '@revolist/vue3-datagrid';
import { saveAs } from 'file-saver';
//import AddDamage from '/src/components/AddDamage.vue';
//import AddInspectionGrid from '/src/components/AddInspectionGrid.vue';
export default {
  components: {
    //AddDamage,
    //AddInspectionGrid,
    RevoGrid,
  },
  created() {
    // determine whether dashboard widgets should be shown based on fetched menuItems
    this.checkMenuForVcn();
    this.checkMenuForTransactionManagement();
    this.checkMenuForCapturedImages();
    // listen for menu updates from App (triggered after login/menu fetch)
    if (typeof window !== 'undefined') {
      window.addEventListener('menuItemsUpdated', () => {
        this.checkMenuForVcn();
        this.checkMenuForTransactionManagement();
        this.checkMenuForCapturedImages();
      });
    }
  },
  unmounted() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('menuItemsUpdated', this.checkMenuForVcn);
    }
  },

  mounted() {
    // Defer non-critical fetching until after the full page load so it runs in background
    const runBackgroundFetches = () => {
      try {
        const tasks = [
          this.fetchStates(),
          this.fetchCountries(),
          this.fetchBanks(),
          this.fetchCFS(),
          this.fetchLocations(),
          this.fetchVessels(),
          this.fetchVoyages(),
          this.fetchApplicants(),
          this.fetchAccounts(),
          this.fetchLinkedParty(),
          this.fetchMovements(),
          this.fetchPorts(),
          this.fetchMasterLocations(),
          this.fetchActiveVCNs(),
          this.fetchActiveImportVCNs(),
          this.fetchNotVerifiedTransactions(),
          this.fetchCapturedImagesCount(),
        ];
        // Run all fetches concurrently and don't block render; log results when done
        Promise.allSettled(tasks).then(results => {
          // log results so eslint doesn't complain about unused variable and for debugging
          console.log('Background data fetches completed', results);
        });
      } catch (e) {
        // last-resort: call each fetch without blocking
        try {
          this.fetchStates();
          this.fetchCountries();
          this.fetchBanks();
          this.fetchCFS();
          this.fetchLocations();
          this.fetchVessels();
          this.fetchVoyages();
          this.fetchApplicants();
          this.fetchAccounts();
          this.fetchLinkedParty();
          this.fetchMovements();
          this.fetchPorts();
          this.fetchMasterLocations();
          this.fetchActiveVCNs();
          this.fetchActiveImportVCNs();
          this.fetchCapturedImagesCount();
        } catch (ee) {
          console.warn('Background fetch fallback failed', ee);
        }
      }
    };

    const schedule = () => {
      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        window.requestIdleCallback(runBackgroundFetches, { timeout: 3000 });
      } else {
        setTimeout(runBackgroundFetches, 600);
      }
    };

    if (typeof window !== 'undefined') {
      if (document.readyState === 'complete') {
        schedule();
      } else {
        window.addEventListener('load', schedule, { once: true });
      }
    } else {
      // server-side or unknown environment: call directly
      schedule();
    }
  },
  data() {
    return {
      activeVCNs: [],
      activeImortVCNs: [],
      importSearch: '',
      activeSearch: '',
      notVerifiedSearch: '',
      isLoadingActiveVCNs: false,
      isLoadingactiveImortVCNs: false,
      isLoadingNotVerified: false,
      notVerifiedCount: 0,
      notVerifiedList: [],
      showNotVerifiedModal: false,
      isLoadingCapturedImages: false,
      capturedImagesCount: 0,
      capturedImagesData: [],
      showCapturedImagesWidget: false,
      showCapturedImagesModal: false,
      DataGridComponent: null,
      notVerifiedColumns: [],
      selectAll: false,
      selectedRows: new Set(),
      showWidgetsGrid: false,
      showNotVerifiedWidget: false,
      showImportVcnModal: false,
      showSetCfsModal: false,
      selectedAdvanceRow: null,
      selectedCfsId: null,
      showVCNModal: false,
      showEditModal: false,
      showAdvanceModal: false,
      advanceListData: [],
      ShowUploadFileModal: false,
      linkParties: JSON.parse(localStorage.getItem('party')),
      selectedShortName: "",
      imagefiles: [],
      applicantID: 0,
      accountID: 0,
      partyname: '',
      UploadFilesList: [],
      SelectedVcnForUpload: null,
      fileoverlayVisible: false,
      currentImage: '',
      currentIndex: 0,
      currentImages: [],
      selectedPartyId: null,
      isDeleteImageConfirmVisible: false,
      cfsList: [],
      bllist: [],
      blSearch: '',
      selectedBlIds: [],
      isLoadingAdvanceList: false,
      isSavingEdit: false,
      newVcn: {
        vcnNo: '',
        vcnName: '',
        vesselID: 0,
        VesselName: '',
        import_voyage: 0,
        import_voyageName: '',
        export_voyage: 0,
        export_voyageName: '',
        MlocID: 0,
        area: '',
        ImpRotNo: '',
        ImpRotDate: null,
        ExpRotNo: '',
        ExpRotDate: null,
        BerthDate: null,
        EgmDate: null,
        IsSail: false,
        SailDate: null,
        vesselLocation: 0,
        Vesselarea: 0,
      },
      // RevoGrid configuration: columns + rows + theme
      columns: [
        {
          prop: 'selected', name: '', size: 40, readonly: true, cellTemplate: (h, { prop, model }) => {
            return h('input', {
              type: 'checkbox',
              checked: model[prop],
              onChange: (e) => {
                model[prop] = e.target.checked;
              }
            });
          }
        },
        { prop: 'sno', name: 'S.No', size: 60, readonly: true },
        { prop: 'contnumber', name: 'Container', sortable: true, size: 130, readonly: true },
        { prop: 'inspdate', name: 'Date', sortable: true, cellProperties: () => ({ placeholder: 'dd/mm/yyyy' }) },
        { prop: 'insptime', name: 'Time', size: 65, sortable: true },
        {
          prop: 'seal', name: 'Seal', cellTemplate: (h, { prop, model }) => {
            const val = model[prop] ?? '';
            const isIntact = (val || '').toString().trim().toLowerCase() === 'intact';
            // Red background only when value is INTACT (case-insensitive)
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                boxSizing: 'border-box',
                padding: '6px 8px',
                backgroundColor: isIntact ? 'red' : 'transparent',
                color: isIntact ? '#ffffff' : 'inherit',
                borderRadius: isIntact ? '3px' : '0'
              }
            }, String(val));
          }
        },
        { prop: 'VesselName', name: 'Vessel', size: 120, readonly: true },
        { prop: 'VoyageName', name: 'Voyage', size: 100, readonly: true },
        { prop: 'LocationName', name: 'Location', readonly: true },
        { prop: 'MovementName', name: 'Movement', readonly: true },
        { prop: 'TLName', name: 'To Loc', readonly: true },
        { prop: 'note', name: 'Note', size: 200 },

      ],
      rows: [],
      compact: 'compact',
    };
  },
  computed: {
    filteredImportVCNs() {
      const q = (this.importSearch || '').toString().trim().toLowerCase();
      if (!q) return this.activeImortVCNs;
      return this.activeImortVCNs.filter(vcn => {
        const vcnName = (vcn.vcnName || vcn.vcn || '').toString().toLowerCase();
        const vessel = (vcn.VesselName || vcn.vesselName || '').toString().toLowerCase();
        const voyage = (vcn.import_voyageName || vcn.VoyageName || vcn.voyageName || '').toString().toLowerCase();
        const area = (vcn.area || '').toString().toLowerCase();
        return vcnName.includes(q) || vessel.includes(q) || voyage.includes(q) || area.includes(q);
      });
    },
    filteredBlList() {
      const q = (this.blSearch || '').toString().trim().toLowerCase();
      if (!q) return this.bllist;
      return this.bllist.filter(bl => {
        const blNo = (bl.blNo || '').toString().toLowerCase();
        const itemNo = (bl.itemno || '').toString().toLowerCase();
        return blNo.includes(q) || itemNo.includes(q);
      });
    }
    ,
    filteredActiveVCNs() {
      const q = (this.activeSearch || '').toString().trim().toLowerCase();
      if (!q) return this.activeVCNs;
      return this.activeVCNs.filter(vcn => {
        const vcnName = (vcn.vcnName || vcn.vcn || '').toString().toLowerCase();
        const vessel = (vcn.VesselName || vcn.vesselName || '').toString().toLowerCase();
        const voyage = (vcn.import_voyageName || vcn.VoyageName || vcn.voyageName || '').toString().toLowerCase();
        const area = (vcn.area || '').toString().toLowerCase();
        return vcnName.includes(q) || vessel.includes(q) || voyage.includes(q) || area.includes(q);
      });
    },
    hasSelectedRows() {
      return this.rows.some(row => row.selected);
    },
    filteredNotVerifiedRows() {
      const q = (this.notVerifiedSearch || '').toString().trim().toLowerCase();
      if (!q) return this.rows;
      return this.rows.filter(row => {
        const container = (row.contnumber || '').toString().toLowerCase();
        const seal = (row.seal || '').toString().toLowerCase();
        const movement = (row.MovementName || '').toString().toLowerCase();
        return container.includes(q) || seal.includes(q) || movement.includes(q);
      });
    }
  },
  methods: {
    async saveSetCfs() {
      const selbls = this.selectedBlIds.length > 0 ? this.selectedBlIds : null;
      if (!selbls) {
        useToast().error('Please select at least one BL to set CFS/ICD.');
        return;
      }
      if (!this.selectedCfsId) {
        useToast().error('Please select a CFS/ICD before saving.');
        return;
      }

      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`, // Include the token in the headers
          }
        };
        const payload = {
          vcnid: this.selectedAdvanceRow.vcnID,
          cfsid: this.selectedCfsId,
          blnos: selbls
        };
        const data = new FormData();
        const payloadEntries = JSON.stringify(payload);
        data.append('payload', payloadEntries);
        const response = await axios.post('/set_cfs_for_bl', data, config);
        if (response.data[0] === 1) {
          useToast().success('CFS/ICD set successfully for selected BL(s).');
          await this.fetch_bl_list();
          //clear checkbox selection 
          this.selectedBlIds = [];
        } else {
          useToast().error(response.data[1] || 'Failed to set CFS/ICD for selected BL(s).');
        }
      }
      catch (error) {
        console.error('Error setting CFS:', error);
        useToast().error(error.response?.data?.message || 'An error occurred while setting CFS');
      }
    },
    async openSetCfsModal(row) {
      this.selectedCfsId = null;
      this.showSetCfsModal = true;
      this.selectedAdvanceRow = row;
      //CALL API TO GET BL NO LIST FOR THAT VCN AND POPULATE IN MODAL
      await this.fetch_bl_list();
      this.selectedBlIds = [];
    },
    async fetch_bl_list() {
      const row = this.selectedAdvanceRow;
      const data = {
        vcnid: row.vcnID,
        applicantid: row.applicantID,
        accountid: row.accountID,
        locationid: row.vmlocid,
        vessselid: row.vesselID,
        voyageid: row.import_voyage
      }
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`, // Include the token in the headers
          }
        };
        const response = await axios.post('/get_bl_list_for_vcn', data, config);
        this.bllist = response.data[2];
      } catch (error) {
        console.error('Error fetching BL list:', error);
        useToast().error('An error occurred while fetching BL list');
      }
    },
    async DownloadFile(row) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`, // Include the token in the headers
          },
          responseType: 'blob'
        };

        const uploadData = new FormData();
        uploadData.append('applicantName', row.applicantID);
        uploadData.append('accountName', row.accountID);
        uploadData.append('location', row.vmlocid);
        uploadData.append('vesselName', row.vesselID);
        uploadData.append('voyageName', row.import_voyage);

        const response = await axios.post('/downLoad_import_list?applicantid=' + row.applicantID + '&accountid=' + row.accountID + '&locationid=' + row.vmlocid + '&vessselid=' + row.vesselID + '&voyageid=' + row.import_voyage, uploadData, config);
        console.log(response)
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          console.log(blob)
          // create a safe filename from VCN, Applicant and Account
          const safe = (s) => (s || '').toString().replace(/[\\/:"*?<>|]+/g, '').replace(/\s+/g, '_').slice(0, 80);
          const vcnName = safe(row.vcnName || row.vcn || row.VCN || 'vcn');
          const applicant = safe(row.ApplicantName || row.applicantName || row.Applicant || 'applicant');
          const account = safe(row.AccountName || row.accountName || row.Account || 'account');
          const filename = `${vcnName}_${applicant}_${account}.xlsx`;
          saveAs(blob, filename);
        }
      } catch (error) {
        console.error('Error downloading file:', error);
        useToast().error('An error occurred while downloading file');
      } finally {
        this.isSubmitting = false;
      }
    },
    //increment(damagedata) {
    //  alert("clicked")
    //  console.log(damagedata);
    //},
    openVCNModal() {
      this.showVCNModal = true;
    },
    closeVCNModal() {
      this.showVCNModal = false;
    },
    openImportVcnModal() {
      this.showImportVcnModal = true;
    },
    closeImportVcnModal() {
      this.showImportVcnModal = false;
    },

    checkMenuForVcn() {
      try {
        // explicit permission check for action key 'vcn' and 'view' permission
        this.showWidgetsGrid = !!hasPermission('vcn', 'view');
      } catch (err) {
        this.showWidgetsGrid = false;
      }
    },
    checkMenuForTransactionManagement() {
      try {
        // explicit permission check for action key 'transactionmanagment' and 'edit' permission
        this.showNotVerifiedWidget = !!hasPermission('transactionmanagment', 'edit');
      } catch (err) {
        this.showNotVerifiedWidget = false;
      }
    },
    checkMenuForCapturedImages() {
      try {
        this.showCapturedImagesWidget = !!hasPermission('get_image_captured_data', 'view');
      } catch (err) {
        this.showCapturedImagesWidget = false;
      }
    },
    setValueToFiled() {
      if (this.newVcn.SailDate != '' && this.newVcn.SailDate != null) {
        if (cs.isvalidDate(this.newVcn.SailDate) == false) {
          useToast().error('Invalid Date');
        }
      }
    },
    editVCN(vcn) {
      // open edit modal with a shallow copy to avoid mutating list before save
      this.newVcn = Object.assign({}, vcn);
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
      this.newVcn = null;
    },
    closeAdvanceModal() {
      this.showAdvanceModal = false;
      this.advanceListData = [];
    },
    closeUploadFileModal() {
      this.ShowUploadFileModal = false;
      this.UploadFilesList = [];
      this.SelectedVcnForUpload = null;
    },
    onFileChange(e) {
      var selectedFiles = e.target.files;
      for (var i = 0; i < selectedFiles.length; i++) {
        this.imagefiles.push(selectedFiles[i]);
      }
    },
    async uploadFiles() {
      const partyId = this.selectedShortName;
      const vcnId = this.SelectedVcnForUpload.vcnID;
      if(partyId==0 || partyId==null || partyId==""){
        useToast().error('Please select party to upload files');
        return;
      }      
      if (!this.imagefiles || this.imagefiles.length === 0) {
        useToast().error('Please select at least one file to upload.');
        return;
      }
      const party = this.linkParties.find(party => party.autoid === this.selectedShortName);
      console.log(party)
      if (party) {
        this.applicantID = party.applicantId
        this.accountID = party.accountId
        this.partyname = party.short_name
      }

      const data = new FormData();
      const fileInput = this.$refs.fileAdd;
      for (const file of fileInput.files) {
        data.append("files", file);
      }
      const transactionData = {
        partyId: partyId,
        vcnId: vcnId,
        applicantID: this.applicantID,
        accountID: this.accountID,
        partyname: this.partyname,
        vcnName: this.SelectedVcnForUpload.vcnName,
        CreateDate: this.SelectedVcnForUpload.CreateDate,
        VesselName: this.SelectedVcnForUpload.VesselName,
        import_voyageName: this.SelectedVcnForUpload.import_voyageName,
        export_voyageName: this.SelectedVcnForUpload.export_voyageName,
      }
      const x = JSON.stringify(transactionData)
      data.append('transaction', x);
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          }
        };
        const response = await axios.post('/upload_files_vcn_party', data, config);
        this.imagefiles = [];
        useToast().success('Files uploaded successfully.');
        console.log('Upload response:', response);
        //this.closeUploadFileModal();
        await this.fetchFilesForVCN(vcnId);
      } catch (error) {
        console.error('Error uploading files:', error);
        useToast().error('An error occurred while uploading files.');
      }
    },
    async ShowUploadFileList(vcn) {
      this.ShowUploadFileModal = true;
      this.SelectedVcnForUpload = vcn;
      this.fetchFilesForVCN(vcn.vcnID);
    },
    async fetchFilesForVCN(vcnId) {
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        };
        const response = await axios.get(`/get_vcn_files?vcnid=${vcnId}`, config);
        this.UploadFilesList = response.data[2] || [];
        console.log(this.UploadFilesList)
      } catch (error) {
        console.error('Error fetching uploaded files:', error);
        useToast().error('An error occurred while fetching uploaded files.');
      }
    },
    async showOverlay(vcnID, partyId) {
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };

        const responce = await axios.get('/get_vcn_files_by_party_vcn?vcnID=' + vcnID + '&partyId=' + partyId, config);
        this.selectedPartyId = partyId;
        this.currentImages = responce.data[2];
        console.log(this.currentImages)
        this.currentIndex = 0;
        this.fileoverlayVisible = true;

        if (this.currentImages.length > 0) {
          const config = {
            headers: {
              'accept': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            responseType: 'blob'
          };
          const folderpath = this.currentImages[0]['folderpath'];
          const filename = this.currentImages[0]['filename'];
          const imagepath = folderpath + '/' + filename;
          const imageRes = await axios.get('/ConvertImageToBlob?filename=' + imagepath, config);
          this.currentImage = URL.createObjectURL(imageRes.data);
        } else {
          this.currentImage = '';
        }
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
      this.$nextTick(() => {
        document.querySelector('.overlay').classList.add('overlay-active');
      });
    },
    async reloadOverlayImages(vcnID, partyId) {
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        const responce = await axios.get('/get_vcn_files_by_party_vcn?vcnID=' + vcnID + '&partyId=' + partyId, config);
        this.selectedPartyId = partyId;
        this.currentImages = responce.data[2];
        console.log(this.currentImages)
        if (this.currentImages.length === 0) {
          this.currentImage = '';
          this.currentIndex = 0;
          return;
        }
        if (this.currentIndex >= this.currentImages.length) {
          this.currentIndex = this.currentImages.length - 1;
        }
        if (this.currentImages.length > 0) {
          const config = {
            headers: {
              'accept': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            responseType: 'blob'
          };
          const folderpath = this.currentImages[0]['folderpath'];
          const filename = this.currentImages[0]['filename'];
          const imagepath = folderpath + '/' + filename;
          const imageRes = await axios.get('/ConvertImageToBlob?filename=' + imagepath, config);
          this.currentImage = URL.createObjectURL(imageRes.data);
        } else {
          this.currentImage = '';
        }
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    },
    async loadImage(index) {

      const token = localStorage.getItem("access_token");

      const config = {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`
        },
        responseType: "blob"
      };

      const folderpath = this.currentImages[index]['folderpath'];
      const filename = this.currentImages[index]['filename'];
      const imagepath = folderpath + '/' + filename;
      const imageRes = await axios.get('/ConvertImageToBlob?filename=' + imagepath, config);

      this.currentImage = URL.createObjectURL(imageRes.data);
    },
    nextImage() {
      if (this.currentIndex < this.currentImages.length - 1) {
        this.currentIndex++;
        this.loadImage(this.currentIndex);
      }
    },
    async triggerAddImage() {
      this.$refs.addImageInput.click();
    },
    async triggerReplaceImage() {
      this.$refs.replaceImageInput.click();
    },
    async deleteCurrentImage() {
        this.isDeleteImageConfirmVisible = true;
    },
    async confirmDeleteImage() {
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        const image = this.currentImages[this.currentIndex];
        const info = {
          auto_id: image.auto_id,
          imagepath: image.filename,
          vcnID: this.SelectedVcnForUpload.vcnID
        };
        const data = new FormData();
        data.append('imageInfo', JSON.stringify(info));
        const response = await axios.post('/delete_vcn_party_image', data, config);
        if (response.data[0] === 1) {
          useToast().success('Image deleted successfully');
          await this.reloadOverlayImages(this.SelectedVcnForUpload.vcnID, this.selectedPartyId);
        } else {
          useToast().error(response.data[1] || 'Failed to delete image');
        }
      } catch (error) {
        useToast().error('Error deleting image');
        console.error(error);
      }
      this.isDeleteImageConfirmVisible = false;
    },
    async onAddImageChange(e) {
      const files = e.target.files;
      if (!files.length) return;
      const token = localStorage.getItem('access_token');
      const data = new FormData();
      const party = this.linkParties.find(party => party.autoid === this.selectedPartyId);

      const info = JSON.stringify({
        vcnID: this.SelectedVcnForUpload.vcnID,
        CreateDate: this.SelectedVcnForUpload.CreateDate,
        vcnName: this.SelectedVcnForUpload.vcnName,
        VesselName: this.SelectedVcnForUpload.VesselName,
        import_voyageName: this.SelectedVcnForUpload.import_voyageName,
        export_voyageName: this.SelectedVcnForUpload.export_voyageName,
        applicantID: party.applicantId,
        accountID: party.accountId,
        partyname: party.short_name,
        partyId: this.selectedPartyId
      });
      console.log(info)
      data.append('transaction', info);
      for (const file of files) {
        data.append('files', file);
      }
      try {
        const response = await axios.post('/add_new_image_for_vcn_party', data, {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${token}` }
        });
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          useToast().success('Image(s) added successfully');
          await this.reloadOverlayImages(this.SelectedVcnForUpload.vcnID, this.selectedPartyId);
        }
      } catch (error) {
        useToast().error('Error adding image');
        console.error(error);
      }
      e.target.value = '';
    },
    async onReplaceImageChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      const token = localStorage.getItem('access_token');
      const data = new FormData();
      const party = this.linkParties.find(party => party.autoid === this.selectedPartyId);
      console.log(this.currentImages[this.currentIndex]);
      const info = JSON.stringify({
        vcnID: this.SelectedVcnForUpload.vcnID,
        CreateDate: this.SelectedVcnForUpload.CreateDate,
        vcnName: this.SelectedVcnForUpload.vcnName,
        VesselName: this.SelectedVcnForUpload.VesselName,
        import_voyageName: this.SelectedVcnForUpload.import_voyageName,
        export_voyageName: this.SelectedVcnForUpload.export_voyageName,
        applicantID: party.applicantId,
        accountID: party.accountId,
        partyname: party.short_name,
        partyId: this.selectedPartyId,
        auto_id: this.currentImages[this.currentIndex]['auto_id'],
        imagepath: this.currentImages[this.currentIndex]['filename'],
      });
      data.append('transaction', info);
      data.append('file', file);
      try {
        const response = await axios.post('/replace_image_for_vcn_party', data, {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${token}` }
        });
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          useToast().success('Image replaced successfully');
          await this.reloadOverlayImages(this.SelectedVcnForUpload.vcnID, this.selectedPartyId);
        }
      } catch (error) {
        useToast().error('Error replacing image');
        console.error(error);
      }
      e.target.value = '';
    },
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.loadImage(this.currentIndex);
      }
    },
    isImage(file) {
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
    },

    isPdf(file) {
      return /\.pdf$/i.test(file);
    },
    closeOverlay() {
      this.currentImages = [];
      this.selectedPartyId = null;
      document.querySelector('.overlay').classList.remove('overlay-active');
      this.fileoverlayVisible = false;
    },
    async showAdvanceList(vcn) {
      // Action handler for Advance List button - call API to get advance list count by VCN
      const toast = useToast();
      const vcnId = vcn.vcnID || vcn.vcn || vcn.id;
      if (!vcnId) {
        toast.error('VCN id not found for Advance List.');
        return;
      }

      const token = localStorage.getItem('access_token');
      const config = token ? { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } } : {};
      try {
        this.isLoadingAdvanceList = true;
        // This endpoint appears to return the advance list rows; use it to populate modal table
        const res = await axios.get(`/get_advancelist_count_byvcn/${vcnId}/`, config);
        let payload = res.data;
        let data = Array.isArray(payload) && payload.length >= 3 ? payload[2] : payload;
        // If API returns an object with a nested array, try common keys
        if (data && typeof data === 'object' && !Array.isArray(data)) {
          // common wrapper keys: results, data, rows
          if (Array.isArray(data.results)) data = data.results;
          else if (Array.isArray(data.data)) data = data.data;
          else if (Array.isArray(data.rows)) data = data.rows;
        }

        this.advanceListData = Array.isArray(data) ? data : [];
        this.showAdvanceModal = true;
      } catch (error) {
        console.error('Error fetching advance list count:', error);
        toast.error(error.response?.data?.message || 'Error fetching advance list');
      } finally {
        this.isLoadingAdvanceList = false;
      }
    },
    async fetchPorts() {
      try {
        const response = await axios.get('/port');
        var data = response.data[2]
        data.push({ portid: 0, name: 'Choose One', description: 'Choose One', PortCode: '' })
        localStorage.setItem('ports', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching ports:', error);
      } finally {
        //console.log(localStorage.getItem('ports'))
      }
    },
    async fetchMovements() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/movement_list', config);
        var data = response.data[2]
        data.push({ Movid: 0, Name: 'Select movement' })
        localStorage.setItem('movements', JSON.stringify(data));
        //console.log(localStorage.getItem('movements'))
      } catch (error) {
        console.error('Error fetching movement list:', error);
      }
    },
    async fetchStates() {
      try {
        const response = await axios.get('/states');
        var data = response.data[2]
        localStorage.setItem('states', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching states:', error);
        //} finally {
        //console.log(localStorage.getItem('states'))
      }
    },
    async fetchCountries() {
      try {
        const response = await axios.get('/countries');
        localStorage.setItem('countries', JSON.stringify(response.data[2]));
      } catch (error) {
        console.error('Error fetching countries:', error);
        //} finally {
        //console.log(localStorage.getItem('countries'))
      }
    },
    async fetchCFS() {
      try {
        const response = await axios.get('/cfs_locations');
        var data = response.data[2]
        data.push({ locationid: 0, Name: 'Select cfs/icd', ShortName: 'Select cfs/icd' })
        data.push({ locationid: 4000, Name: 'Party', ShortName: 'Party' })
        localStorage.setItem('cfs_location', JSON.stringify(data));
        this.cfsList = data;
      } catch (error) {
        console.error('Error fetching countries:', error);
        //} finally {
        //console.log(localStorage.getItem('cfs_location'))
      }
    },
    async fetchBanks() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        this.isLoading = false;
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/banks', config);
        var data = response.data[2]
        data.push({ autoid: 0, BankName: 'Select banks' })
        localStorage.setItem('banks', JSON.stringify(data));

      } catch (error) {
        console.error('Error fetching banks:', error);
        //} finally {
        //console.log(localStorage.getItem('banks'))
      }
    },
    async fetchLocations() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/location_list', config);
        var data = response.data[2]
        data.push({ locationid: 0, Name: 'Select location', ShortName: 'Select location' })
        data.push({ locationid: 4000, Name: 'Party', ShortName: 'Party' })
        localStorage.setItem('locations', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching location list:', error);
        //} finally {
        //console.log(localStorage.getItem('locations'))
      }
    },
    async fetchMasterLocations() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/master_location_list', config);
        var data = response.data[2]
        data.push({ locationid: 0, Name: 'Select location', ShortName: 'Select location' })
        localStorage.setItem('Area', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching master location list:', error);
        //} finally {
        //console.log(localStorage.getItem('locations'))
      }
    },
    async fetchVessels() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        this.isLoading = false;
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/vessel_list', config);
        var data = response.data[2]
        data.push({ Vesselid: 0, Name: 'Select vessel' })
        localStorage.setItem('vessel', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching vessel list:', error);
        //} finally {
        //console.log(localStorage.getItem('vessel'))
      }
    },
    async fetchVoyages() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        };
        const response = await axios.get('/voyage_list', config);
        var data = response.data[2]
        data.push({ Voyageid: 0, Name: 'Select voyage' })
        localStorage.setItem('voyage', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching voyage list:', error);
        //} finally {
        //console.log(localStorage.getItem('voyage'))
      }
    },
    async fetchApplicants() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/applicant_list/', config);
        var data = response.data[2]
        data.push({ applicantid: 0, applicantname: 'Select applicant' })
        localStorage.setItem('applicants', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching applicant list:', error);
        //} finally {
        //console.log(localStorage.getItem('applicants'))
      }
    },
    async fetchAccounts() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/accounts/', config);
        var data = response.data[2]
        data.push({ accountid: 0, accountname: 'Select account' })
        localStorage.setItem('accounts', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching accounts:', error);
        //} finally {
        //console.log(localStorage.getItem('accounts'))
      }
    },
    async fetchLinkedParty() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        this.error = 'No token found in localStorage';
        return;
      }
      try {
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.get('/linkParties', config);
        var data = response.data[2]
        data.push({ autoid: 0, short_name: 'Select Party' })
        localStorage.setItem('party', JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching party:', error);
        //} finally {
        //console.log(localStorage.getItem('party'))
      }
    },
    async fetchActiveVCNs() {
      this.isLoadingActiveVCNs = true;
      try {
        const token = localStorage.getItem('access_token');
        const config = token ? { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } } : {};
        const response = await axios.get('/active_vcn_list', config);
        // API returns data in [status, message, data] pattern in many places
        const data = Array.isArray(response.data) && response.data.length >= 3 ? response.data[2] : response.data;
        //console.log('Fetched active VCNs:', data);
        this.activeVCNs = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Error fetching active VCNs:', error);
        this.activeVCNs = [];
      } finally {
        this.isLoadingActiveVCNs = false;
      }
    },
    async fetchActiveImportVCNs() {
      this.isLoadingactiveImortVCNs = true;
      try {
        const token = localStorage.getItem('access_token');
        const config = token ? { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } } : {};
        const response = await axios.get('/get_active_import_vcn', config);
        // API returns data in [status, message, data] pattern in many places
        const data = Array.isArray(response.data) && response.data.length >= 3 ? response.data[2] : response.data;
        //console.log('Fetched active VCNs:', data);
        this.activeImortVCNs = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Error fetching active VCNs:', error);
        this.activeImortVCNs = [];
      } finally {
        this.isLoadingactiveImortVCNs = false;
      }
    },
    async fetchNotVerifiedTransactions() {
      this.isLoadingNotVerified = true;
      try {
        const token = localStorage.getItem('access_token');
        const config = token ? { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } } : {};
        const response = await axios.get('/not_verified_transactions', config);
        // flexible parsing: many endpoints return [status, message, data]
        let payload = response.data;
        let data = Array.isArray(payload) && payload.length >= 3 ? payload[2] : payload;

        let count = 0;
        // normalize list and count
        if (typeof data === 'number') {
          count = data;
          this.notVerifiedList = [];
        } else if (Array.isArray(data)) {
          count = data.length;
          this.notVerifiedList = data;
        } else if (data && typeof data === 'object') {
          // try common wrapper keys
          if (Array.isArray(data.results)) {
            this.notVerifiedList = data.results;
            count = data.results.length;
          } else if (Array.isArray(data.data)) {
            this.notVerifiedList = data.data;
            count = data.data.length;
          } else if (Array.isArray(data.rows)) {
            this.notVerifiedList = data.rows;
            count = data.rows.length;
          } else {
            count = Number(data.count ?? data.total ?? data.total_count ?? 0) || 0;
            this.notVerifiedList = [];
          }
        } else {
          this.notVerifiedList = [];
        }

        this.notVerifiedCount = count;
      } catch (error) {
        console.error('Error fetching not verified transactions:', error);
        this.notVerifiedCount = 0;
        this.notVerifiedList = [];
      } finally {
        this.isLoadingNotVerified = false;
      }
    },

    async fetchCapturedImagesCount() {
      this.isLoadingCapturedImages = true;
      try {
        const token = localStorage.getItem('access_token');
        const config = token ? { headers: { accept: 'application/json', Authorization: `Bearer ${token}` } } : {};
        const response = await axios.get('/get_image_captured_count', config);
        console.log('Captured images count response:', response);
        let payload = response.data;
        let data = Array.isArray(payload) && payload.length >= 3 ? payload[2] : payload;
        let count = 0;
        if (typeof data === 'number') {
          count = data;
          this.capturedImagesData = [];
        } else if (Array.isArray(data)) {
          // Store the array for modal display and sum all 'total' values
          this.capturedImagesData = data;
          count = data.reduce((sum, item) => sum + (Number(item.total) || 0), 0);
        } else if (data && typeof data === 'object') {
          count = Number(data.count ?? data.total ?? data.total_count ?? 0) || 0;
          this.capturedImagesData = [];
        }
        this.capturedImagesCount = count;
      } catch (error) {
        console.error('Error fetching captured images count:', error);
        this.capturedImagesCount = 0;
        this.capturedImagesData = [];
      } finally {
        this.isLoadingCapturedImages = false;
      }
    },

    openCapturedImagesModal() {
      this.showCapturedImagesModal = true;
    },

    closeCapturedImagesModal() {
      this.showCapturedImagesModal = false;
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDateToDDMMYYYY(dateValue) {
      if (!dateValue) return '';
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return dateValue;
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    async openNotVerifiedModal() {
      this.showNotVerifiedModal = true;
      // fetch latest list if empty
      if (!this.notVerifiedList || this.notVerifiedList.length === 0) {
        await this.fetchNotVerifiedTransactions();
      }
      console.log(this.notVerifiedList);
      // prepare rows for RevoGrid with formatted date
      this.rows = this.notVerifiedList.map((row, idx) => ({
        selected: false,
        sno: idx + 1,
        ...row,
        inspdate: this.formatDateToDDMMYYYY(row.inspdate)
      }));
      this.selectAll = false;
      this.selectedRows.clear();
    },

    // handler for RevoGrid cell edits
    async onCellEdit(event) {
      try {
        // RevoGrid may emit different event shapes; log for debugging
        console.log('RevoGrid afteredit event:', event);
        var { model, prop, val, row } = event.detail;
        console.log(model, prop, val);
        const data = new FormData();
        var modeldata = model
        modeldata.prop = prop;
        var transdt = JSON.stringify(model)
        console.log(transdt)
        data.append('prop', prop);
        data.append('transaction', transdt)
        console.log(data);
        const token = localStorage.getItem('access_token');
        if (!token) {
          console.error('No token found in localStorage');
          return;
        }
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        const response = await axios.post('/update_not_verified_transaction', data, config);
        console.log(response.data);
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          useToast().success("Updated successfully");
          const updatedRow = {
            ...this.notVerifiedList[row]
          };
          this.notVerifiedList.splice(row, 1, updatedRow);
        }
      } catch (e) {
        console.warn('Error handling RevoGrid edit:', e);
      }
    },

    toggleSelectAll() {
      // Toggle all checkboxes in the grid
      this.rows = this.rows.map(row => ({
        ...row,
        selected: this.selectAll
      }));
      if (this.selectAll) {
        this.selectedRows = new Set(this.rows.map((_, idx) => idx));
      } else {
        this.selectedRows.clear();
      }
    },

    async verifySelected() {
      const toast = useToast();
      const selectedItems = this.rows.filter(row => row.selected);

      if (selectedItems.length === 0) {
        toast.warning('Please select at least one transaction to verify');
        return;
      }

      try {
        // Extract reportids from selected items
        const reportIds = selectedItems.map(item => item.reportid).filter(id => id != null);

        if (reportIds.length === 0) {
          toast.warning('No valid report IDs found in selected items');
          return;
        }

        console.log('Verifying report IDs:', reportIds);
        const updateData = {
          'checkedIds': reportIds
        }

        const data = new FormData();
        const transdt = JSON.stringify(updateData)
        console.log(updateData)
        console.log(transdt)
        data.append('transaction', transdt)
        const token = localStorage.getItem('access_token');
        if (!token) {
          toast.error('No authentication token found');
          return;
        }

        const config = {
          headers: {
            accept: 'application/json',
            Authorization: `Bearer ${token}`
          }
        };

        const response = await axios.post('/verify_transactions', data, config);

        if (response.data[0] === 0) {
          toast.error(response.data[1] || 'Verification failed');
        } else {
          toast.success(`${reportIds.length} transaction(s) verified successfully`);
          // Refresh the list after verification
          await this.fetchNotVerifiedTransactions();
          this.showNotVerifiedModal = false;
        }
      } catch (error) {
        console.error('Error verifying transactions:', error);
        toast.error(error.response?.data?.message || 'Failed to verify transactions');
      }
    },

    closeNotVerifiedModal() {
      this.showNotVerifiedModal = false;
    },
    async saveEdit() {
      const toast = useToast();
      if (!this.newVcn) return;
      this.isSavingEdit = true;
      //console.log('Edit VCN data to save:', this.newVcn);
      try {
        const formattedVcn = { ...this.newVcn };
        //console.log('Saving edited VCN:', formattedVcn);
        if (formattedVcn.IsSail === 1) {
          if (formattedVcn.SailDate == '' || formattedVcn.SailDate == null) {
            useToast().error('Please enter Sail Date');
            this.isSavingEdit = false;
            return;
          }
          if (cs.isvalidDate(formattedVcn.SailDate) == false) {
            useToast().error('Invalid Sail Date');
            this.isSavingEdit = false;
            return;
          }
        }
        formattedVcn.SailDate = cs.ConvertToISODate(formattedVcn.SailDate)
        const token = localStorage.getItem('access_token');
        if (!token) {
          console.error('No token found in localStorage');
          return;
        }
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        };
        // Try calling update endpoint; fallback to local update if endpoint not available
        try {
          const res = await axios.put(`/update_vcn/${formattedVcn.vcnID}/`, formattedVcn, config);
          //console.log('Update response:', res);
          if (res.data && res.data[0] == 1) {
            // Remove the updated row from the activeVCNs list
            this.activeVCNs = this.activeVCNs.filter(vcn => vcn.vcnID !== formattedVcn.vcnID);

            toast.success('VCN updated and removed from the active list.');
          } else {
            throw new Error(res.data[1] || 'Update failed');
          }

        } catch (apiErr) {
          console.warn('update_vcn API failed or not available, removing row locally', apiErr);
          // Fallback: remove the row locally so it no longer appears in the active list
          this.activeVCNs = this.activeVCNs.filter(vcn => vcn.vcnID !== formattedVcn.vcnID);
          toast.success('VCN removed from the active list (local fallback).');
        }
        this.showEditModal = false;
        this.newVcn = null;
      } catch (error) {
        console.error('Error saving edit:', error);
      } finally {
        this.isSavingEdit = false;
      }
    },
  }
}

</script>

<style scoped>
.dashboard {
  padding: 20px;
}

.form-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 5px;
}

.form-item {
  width: 30%;
}

.widgets {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.widgets-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

/* Responsive breakpoints similar to Bootstrap's grid */
@media (max-width: 1199.98px) {

  /* xl down -> 3 columns */
  .widgets-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 991.98px) {

  /* lg down -> 2 columns */
  .widgets-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 575.98px) {

  /* sm down -> 1 column */
  .widgets-grid {
    grid-template-columns: 1fr;
  }
}

.widget-card {
  position: relative;
  padding: 0px 16px 16px 16px;
  border-radius: 12px;
  /* glossy gradient background */
  background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 40%, #e9f2ff 100%);
  /* subtle translucent border to enhance 'card' feel */
  border: 1px solid rgba(255, 255, 255, 0.6);
  /* outer shadow + slight inner highlight for depth */
  box-shadow: 0 6px 18px rgba(11, 34, 71, 0.10), inset 0 1px 0 rgba(255, 255, 255, 0.7);
  overflow: hidden;
  transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
}

/* glossy reflection */
.widget-card::after {
  content: '';
  position: absolute;
  left: -50%;
  top: -60%;
  width: 200%;
  height: 120%;
  background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0) 40%);
  transform: rotate(25deg);
  opacity: 0.6;
  pointer-events: none;
}

.widget-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(11, 34, 71, 0.16);
}

.widget-card h3 {
  /* make header span full width of the card (edge-to-edge inside padding) */
  display: block;
  margin: 0 -16px 12px -16px;
  /* extend to card inner edges (card padding = 16px) */
  padding: 10px 16px;
  border-radius: 12px 12px 0 0;
  /* match card top corners */
  /* stronger banner background that spans full width */
  background: linear-gradient(90deg, rgba(11, 58, 140, 0.12) 0%, rgba(11, 58, 140, 0.06) 100%);
  color: #07326a;
  /* deeper blue header */
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.6);
  text-align: center;
}

.widget-subtitle {
  font-size: 12px;
  color: #6c757d;
  text-align: center;
  margin: -8px 0 4px 0;
  font-style: italic;
}

.widget-count {
  font-size: 28px;
  font-weight: 700;
  color: #007bff;
  margin: 8px 0 12px 0;
  cursor: pointer;
  text-align: center;
  display: block;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  width: 95%;
  max-width: 1400px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  /* make it a positioned container so nested overlay can be absolute inside */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.select-all-container {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 16px;
}

.select-all-container input[type="checkbox"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.verify-button {
  margin-left: 12px;
  padding: 6px 16px;
  border-radius: 4px;
  border: none;
  background: #28a745;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;
}

.verify-button:hover:not(:disabled) {
  background: #218838;
}

.verify-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-body {
  padding: 16px;
  /* fixed height for modal content area to keep header/footer visible
     and make the content scrollable. Use max-height as a safety for
     small screens so it never exceeds viewport. */
  height: 600px;
  max-height: 75vh;
  overflow: scroll;
  display: flex;
  flex-direction: column;
}

.grid-container {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.modal-footer {
  padding: 12px 16px;
  border-top: 1px solid #eee;
  text-align: right;
}

.close-btn {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

.vcns-table {
  width: 100%;
  border-collapse: collapse;
}

.vcns-table th,
.vcns-table td {
  padding: 8px 10px;
  border: 1px solid #eee;
  text-align: left;
}

.vcns-table th {
  background: #f5f5f5;
}

.search-input {
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 360px;
  max-width: 60%;
}

.search-inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-label {
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.cancel-button {
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  background: #6c757d;
  color: #fff;
  cursor: pointer;
}

.edit-button {
  padding: 6px 10px;
  border-radius: 4px;
  border: none;
  background: #007bff;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.edit-button:hover {
  background: #0056b3;
}

/* Edit modal form grid */
.edit-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 16px;
  align-items: center;
}

.edit-grid label {
  font-weight: 600;
}

.save-button {
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  background: #28a745;
  color: #fff;
  cursor: pointer;
}

.save-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Nested modal (renders on top of a parent modal's content) */
.nested-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  /* sits above modal content */
}

.nested-modal-content {
  background: #fff;
  width: 95%;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}

.table-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.table-body-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.table-wrapper .vcns-table {
  width: 100%;
}

.table-wrapper .vcns-table thead th {
  position: sticky;
  top: 0;
  background: #f5f5f5;
  z-index: 1;
}

.table-body-scroll .vcns-table thead {
  display: none;
}

.table-wrapper .vcns-table th:nth-child(1),
.table-wrapper .vcns-table td:nth-child(1) {
  width: 60px;
}

.table-wrapper .vcns-table th:nth-child(2),
.table-wrapper .vcns-table td:nth-child(2) {
  width: 150px;
}

.table-wrapper .vcns-table th:nth-child(3),
.table-wrapper .vcns-table td:nth-child(3) {
  width: calc(100% - 210px);
}

.captured-images-modal {
  max-width: 600px;
}

/* Overlay container */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out;
}

/* Make overlay visible when active */
.overlay-active {
  opacity: 1;
  visibility: visible;
}

/* Overlay content with smooth scaling */
.overlay-content {
  position: relative;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  max-width: 80vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: scale(0.9);
  transition: transform 0.3s ease-in-out;
}

/* Smooth transition when opening */
.overlay-active .overlay-content {
  transform: scale(1);
}

/* Image inside overlay */
.overlay-content img {
  max-width: 70vw;
  max-height: 70vh;
  object-fit: contain;
}

/* Navigation buttons */
.nav-button {
  background-color: #fff;
  border: none;
  font-size: x-large;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.nav-button:hover {
  transform: scale(1.2);
}

/* Left navigation button */
.left {
  position: absolute;
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
}

/* Right navigation button */
.right {
  position: absolute;
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
}
/* Overlay container */
.edit-overlay {
  position: fixed;
  /* Ensures the overlay stays above all other content */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  /* Enables scrolling if the content exceeds viewport height */
  z-index: 9999;
  /* Ensures it appears above all other content */
}

/* Overlay content */
.edit-overlay-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  /* Adjusted width for better fit */
  /*max-width: 1000px;*/
  /* Adjusted max-width */
  max-height: 90vh;
  /* Limits the height to prevent overflow */
  overflow-y: auto;
  /* Enables vertical scrolling within the content */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  margin-top: 50px;
  /* Adds margin from the top */
}
.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.overlay-action-btn {
  border: none;
  border-radius: 4px;
  padding: 5px 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: opacity 0.2s;
}

.overlay-action-btn:hover {
  opacity: 0.8;
}

.add-img-btn {
  background-color: #28a745;
  color: #fff;
}

.replace-img-btn {
  background-color: #007bff;
  color: #fff;
}

.delete-img-btn {
  background-color: #dc3545;
  color: #fff;
}

.close-img-btn {
  background-color: #807d7d;
  color: #fff;
}

.no-image {
  padding: 30px 20px;
  color: #888;
  font-size: 15px;
  text-align: center;
  min-width: 200px;
}
</style>
